import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Textarea } from "../../../input/textarea";
import { FormErrorMessage, FormItem, FormLabel } from "../../_base/form";

import type { ChangeEventHandler } from "react";

export type Props = {
	value: string | undefined;
	handleChange: (input: string) => void;
	placeholder?: string;
	rows?: number;

	errorMessage?: string;
	label?: string;

	//
	onFocusCallback?: () => void;
};

export const TextAreaField = ({
	value,
	handleChange: onChange,
	placeholder,
	rows,
	errorMessage,
	label,
	onFocusCallback,
}: Props) => {
	const handleChange = useCallback<ChangeEventHandler<HTMLTextAreaElement>>(
		(e) => {
			const { value } = e.currentTarget;
			onChange(value);
		},
		[onChange],
	);

	const handleFocus = useCallback(() => {
		onFocusCallback && onFocusCallback();
	}, [onFocusCallback]);

	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>
			<Textarea
				rows={rows}
				onChange={handleChange}
				onFocus={handleFocus}
				value={value}
				className={cn("min-h-[110px]")}
				placeholder={placeholder}
			/>
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
